<template>
  <div>
    <button id="circleListToggleBtn" data-toggle="modal" data-target="#CircleListModal" hidden></button>
    <div class="content">
      <div>
        <div class="content-header">
          <div class="d-flex align-items-start">
            <img v-if="campaign.profile && campaign.profile.upload && campaign.profile.upload.path" class="content-header__avatar rounded-circle mt-1"
              width="40" height="40" :src="campaign.profile.upload.path" alt/>
            <img v-else class="content-header__avatar rounded-circle mt-1" width="40" src="../../../assets/avatar.png" alt/>
            <div class="content-header__description ml-2">
              <div class="content-header__info">
                <router-link :to="'/profile/' + campaign.profile_id" class="content-header__name">{{ campaign.profile.name }}</router-link>
                <div v-if="circles.length && source !== 'circle'" inline>
                  <span role="action" class="text-muted ml-1">in</span>
                  <router-link :to="'/circle/' + circles[0]._id" class="content-header__supplementary mx-1">{{ campaign.circles[0].title }}</router-link>
                  <a href="#" @click.prevent="showCircleList()" v-if="otherCirclesLength">and {{otherCirclesLength}} other {{otherCirclesLength === 1 ? 'circle' : 'circles'}}</a>
                </div>
              </div>
              <div class="content-header__meta">
                <template v-if="circles && circles.length">
                  <span role="role" v-if="campaignAuthorIsAdmin">Admin</span>
                  <span role="role" v-else>Member</span> &middot;
                </template>
                <span role="time">{{ campaign.created | happroxy }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <div class="content-body__title">
            <div inline>
              <span class="font-weight-bold">{{ campaign.title }}</span>
            </div>
          </div>
          <div class="content-body__text">
            <p>{{ campaign.description }}</p>
          </div>
        </div>

        <div class="content-footer" v-if="source === 'profile' && loggedInUser._id === campaign.profile_id">
          <div class="action-links"></div>
          <div style="border: none !important" class="action-links d-flex justify-content-end my-0 mt-2 py-0">
            <button @click="editCampaign()" class="ml-2 btn btn-xs btn-light">
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal topic-thread-modal fade w-100" id="CircleListModal" tabindex="-1" role="dialog" aria-labelledby="CircleListModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Campaign Circles
            </h5>
            <button data-dismiss="modal" type="button" class="close" aria-label="Close">
                <span aria-hidden="true">
                  <ion-icon name="ios-close" size="large"></ion-icon>
                </span>
            </button>
          </div>
          <div class="modal-body">
            <router-link :to="circle ? `/circle/${circle._id}` : ''" data-dismiss="modal" v-for="circle in campaign.circles" :key="circle._id">
              <div class="content mb-2">
                <div>
                  <div class="content-header">
                    <div class="d-flex align-items-start">
                      <img v-if="circle.upload && circle.upload.path" class="content-header__avatar rounded-circle mt-1" width="40" height="40" :src="circle.upload.path" alt />
                      <img v-else class="content-header__avatar rounded-circle mt-1" width="40" src="../../../assets/avatar.png" alt />

                      <div class="content-header__description ml-2">
                        <div class="content-header__info">
                          <span class="content-header__name mr-1">{{ circle.title }}</span>
                        </div>
                        <div class="content-header__meta">
                          <span role="role" v-if="circle.is_admin">Admin</span>
                          <span role="role" v-else>Member</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "CampaignFeedItem",
      props: ["campaign", "source", "loggedInUser", "circle_id"],
      methods: {
        editCampaign() {
          this.$root.$emit("editCampaign", this.$props.campaign);
        },
        showCircleList() {
          document.getElementById('circleListToggleBtn').click();
        }
      },
      computed: {
        otherCirclesLength: function() {
          return this.circles.slice(1).length;
        },
        campaignAuthorIsAdmin: function() {
          if (this.$props.source === 'profile') {
            return this.circles[0].is_admin;
          }

          if (this.$props.source === 'circle') {
            return (this.$props.campaign.assets.circle.find(s => s.identifier === this.$props.circle_id) || {}).is_admin
          }
        },
        circles: function() {
          return this.$props.campaign.circles ? this.$props.campaign.circles.filter(s => s) : [];
        }
      }
    }
</script>

<style lang="scss" scoped>
    .content {
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #efefef;
    position: relative;
    .content-header {
        padding: 20px;
        .content-header__name {
        color: var(--deep-blue);
        font-weight: 700;
        }
        .content-header__supplementary {
        color: var(--deep-blue);
        }
        .content-header__meta {
        color: var(--light-grey);
        font-size: 13px;
        }
    }

    .content-body {
        padding: 0 20px 20px;
        .content-body__title {
        align-items: center;
        padding-bottom: 10px;
        display: flex;
        justify-content: space-between;
        }
        .content-body__text p {
        margin-bottom: 0
        }
    }

    .content-media {
        padding: 0 0 20px;
        &:hover {
        cursor: zoom-in;
        }
    }

    .content-footer {
        padding: 0 20px 20px;
        .action-links {
        border-bottom: 1px solid #efefef;
        padding-bottom: 15px;
        .action-link {
            display: flex;
            align-items: center;
            color: var(--grey);
            font-weight: 700;
            &:hover {
            text-decoration: none;
            }
            ion-icon {
            color: #d5d5d5;
            font-size: 18px;
            margin-right: 4px;
            }
        }
        .action-link + .action-link {
            margin-left: 1.25rem;
        }
        }
        .add-comment {
        .comment-input {
            position: relative;
            .form-control {
            appearance: none;
            background: rgba(47, 113, 255, 0.05);
            border: 0px solid rgba(47, 113, 255, 0.2);
            font-size: 14px;
            padding-right: 40px;
            height: 33px;
            min-height: 33px;
            transition: all ease-in-out 0.3s;
            &:focus {
                height: 66px;
            }
            }
            ion-icon {
            font-size: 18px;
            position: absolute;
            top: 9px;
            right: 10px;
            opacity: 0.6;
            transition: opacity ease-in-out 0.3s;
            &:hover {
                opacity: 1;
                cursor: pointer;
            }
            }
        }
        }
    }

    .content-comments {
        border-top: 1px solid #efefef;
        padding: 20px;
        .content-comments__single {
        background: #F5F7FA;
        margin-bottom: 20px;
        border-radius: 10px;
        .content-media {
            padding: 0 20px 20px;
        }
        }
    }
    }
    div.d-flex.justify-content-end.flex-hidden {
    display: none !important;
    }
</style>